import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _GlobalSidebarSkeleto, _GlobalSidebarSkeleto2;
var _excluded = ["children", "useV2"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "forceSidebarVersion"];
import { lazy, Suspense } from 'react';
import { useFeatureFlag } from '@crehana/feature-flags/react';
import { FEATURE_FLAGS_V5 } from "../../CrossPlatformNavigation/featureFlags";
import { GlobalSidebarSkeleton } from "./global-sidebar-skeleton";
import { jsx as _jsx } from "react/jsx-runtime";
var LayoutWithNavbarAndSidebarV1 = /*#__PURE__*/lazy(function () {
  return import("./layout-with-navbar-and-sidebar-v1").then(function (module) {
    return {
      "default": module.LayoutWithNavbarAndSidebarV1
    };
  });
});
var LayoutWithNavbarAndSidebarV2 = /*#__PURE__*/lazy(function () {
  return import("./layout-with-navbar-and-sidebar-v2").then(function (module) {
    return {
      "default": module.LayoutWithNavbarAndSidebarV2
    };
  });
});
var SidebarProviderV1 = /*#__PURE__*/lazy(function () {
  return import("../../sidebar").then(function (module) {
    return {
      "default": module.SidebarProvider
    };
  });
});
var SidebarProviderV2 = /*#__PURE__*/lazy(function () {
  return import("../../sidebar-v2").then(function (module) {
    return {
      "default": module.SidebarProvider
    };
  });
});
var LayoutWithNavbarAndSidebarContent = function LayoutWithNavbarAndSidebarContent(_ref) {
  var children = _ref.children,
    useV2 = _ref.useV2,
    sidebarProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: _GlobalSidebarSkeleto || (_GlobalSidebarSkeleto = /*#__PURE__*/_jsx(GlobalSidebarSkeleton, {})),
    children: useV2 ? /*#__PURE__*/_jsx(SidebarProviderV2, {
      onNavigate: sidebarProps.onHandledUrlClick,
      handledPathnames: sidebarProps.handledPathnames,
      children: /*#__PURE__*/_jsx(LayoutWithNavbarAndSidebarV2, _objectSpread(_objectSpread({}, sidebarProps), {}, {
        children: children
      }))
    }) : /*#__PURE__*/_jsx(SidebarProviderV1, {
      children: /*#__PURE__*/_jsx(LayoutWithNavbarAndSidebarV1, _objectSpread(_objectSpread({}, sidebarProps), {}, {
        children: children
      }))
    })
  });
};
var LayoutWithFeatureFlag = function LayoutWithFeatureFlag(_ref2) {
  var children = _ref2.children,
    sidebarProps = _objectWithoutProperties(_ref2, _excluded2);
  var _useFeatureFlag = useFeatureFlag(FEATURE_FLAGS_V5.SIDEBAR_V2, 'V5'),
    isSidebarV2Enabled = _useFeatureFlag.flagValue,
    loading = _useFeatureFlag.loading;
  if (loading) {
    return _GlobalSidebarSkeleto2 || (_GlobalSidebarSkeleto2 = /*#__PURE__*/_jsx(GlobalSidebarSkeleton, {}));
  }
  return /*#__PURE__*/_jsx(LayoutWithNavbarAndSidebarContent, _objectSpread(_objectSpread({}, sidebarProps), {}, {
    useV2: isSidebarV2Enabled,
    children: children
  }));
};
export var LayoutWithNavbarAndSidebar = function LayoutWithNavbarAndSidebar(_ref3) {
  var children = _ref3.children,
    forceSidebarVersion = _ref3.forceSidebarVersion,
    sidebarProps = _objectWithoutProperties(_ref3, _excluded3);
  if (forceSidebarVersion !== undefined) {
    return /*#__PURE__*/_jsx(LayoutWithNavbarAndSidebarContent, _objectSpread(_objectSpread({}, sidebarProps), {}, {
      useV2: forceSidebarVersion === 'v2',
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(LayoutWithFeatureFlag, _objectSpread(_objectSpread({}, sidebarProps), {}, {
    children: children
  }));
};